import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/material';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-multi-select-type',
  templateUrl: './multi-select-type.component.html',
  styleUrls: ['./multi-select-type.component.scss']
})
export class MultiSelectTypeComponent extends FieldType {
  formControl: FormControl;

  constructor() {
    super();
  }

  updateModel(event): void {
    this.field.templateOptions.change(this.field, event.value);
  }
}
